<template>
    <div ref="deleteAccountBlock" class="row">
        <div class="col-sm-12 mb-3" >
            <div class="d-flex flex-column gap-3 text-center align-items-center">
	            <i class="bi w-auto h-auto fs-large bi-shield-fill-minus"></i>
                <h3 class="fw-semi-bold m-0">Delete Account</h3>
                <p class="text-secondary m-0">Are you sure you want to delete your account.</p>
	            <p class="text-secondary m-0">You account will be deleted in 14 days if you don't login. If you login during that time account deletion request will be cancelled.</p>
	            <p class="text-secondary m-0">You will be logged out from everywhere and will need to login again.</p>
	            <p class="text-secondary m-0">I am deleting the account at my own risk. After deletion is done all your data will be deleted and can't be recovered.</p>
            </div>
        </div>

        <div class="col-12">
            <div class="d-flex flex-row align-items-center justify-content-center gap-3 text-center ">
                <button class="btn btn-outline-secondary rounded-pill py-2 px-3" @click="close">Cancel</button>
                <button class="btn btn-dark rounded-pill py-2 px-3" @click="deleteAccount">Yes, Delete Account</button>
            </div>
        </div>
    </div>

</template>

<script setup>
import { watch, ref } from "vue";
import {useAppHelpers} from "@/composables/useAppHelpers.js";
import { useAuthStore } from "@/stores/auth-store.js";
import { useToast } from "@/composables/useToast.js";
import apiClient from "@/utils/axios.js";
import { useHttpErrorManager } from "@/composables/useHttpErrorManager.js";

const emits = defineEmits(['closeDeleteAccount']);

const auth = useAuthStore();
const helper = useAppHelpers();
const { displayToast } = useToast();

const deleteAccountBlock = ref(null);

const user = ref(auth.user);
watch(() => auth.user, (newVal) => {
	user.value = newVal;
});

const deleteAccount = async () => {
	try{
		helper.loaderOn(deleteAccountBlock.value);
		const response = await apiClient.post('member/account/delete', {
		});

		if(response.status >= 200 && response.status < 300){
			displayToast('Account deletion request has been submitted. You will be logged out from everywhere and will need to login again to remove the account deletion request.', 'outline-success', 8000);
			setTimeout(async () => {
				await auth.processLogout();
				await close();
			}, 2000);

		}
		helper.loaderOff(deleteAccountBlock.value);
	}
	catch (error) {
		await useHttpErrorManager().handleError(error, true);
		helper.loaderOff(deleteAccountBlock.value);
	}
}

const close = async () => {
	emits('closeDeleteAccount');
}

defineExpose({
    close
});
</script>
